/* =============================================================================
 *  GraphiteHomePage — the dashboard rendered at /dashboard when the Graphite
 *  theme is active (wired through DashboardWrapper).
 *
 *  Renders the command WALL (GodWall): a weight-sized bento mosaic of what needs
 *  the owner — client emails, open jobs, money, ads — sized by importance, with
 *  programmatic-first actions and Andrei one tap away.
 *
 *  Wrapped in InvoiceProvider + BillsProvider so the shared feed model
 *  (useFeedModel → useInvoice/useBills) resolves. No new Firestore queries.
 * ============================================================================= */

import React from 'react';
import { InvoiceProvider } from '../../pages/invoices/contexts/InvoiceContext';
import { BillsProvider } from '../../pages/bills/contexts/BillsContext';
import GodWall from './GodWall';
import AndreiTasksCard from '../../pages/home/sections/AndreiTasksCard';
import '../../pages/home/HomePage.scss';

const GraphiteHomePage: React.FC = () => (
  <InvoiceProvider>
    <BillsProvider>
      <GodWall />
      <div className="graphite-andrei-tasks"><AndreiTasksCard /></div>
    </BillsProvider>
  </InvoiceProvider>
);

export default GraphiteHomePage;
